// eslint-disable-next-line import/prefer-default-export
export const replaceTemplateWithFieldValue = (linkTargetTemplate = '') => ({ value }: { value?: string }) => linkTargetTemplate.replace('{field_value}', String(value));
